// extracted by mini-css-extract-plugin
export default {"cancel":"modalbutton_cancel__ErpcT","accept":"modalbutton_accept__2K5A0"};